module.exports = __webpack_public_path__ + "img/暂无内容.3cd31b60.png";